import { useState } from "react";

interface ShareBarProps {
  title: string;
  className?: string;
}

export default function ShareBar({ title, className = "" }: ShareBarProps) {
  const [toast, setToast] = useState("");
  const [liked, setLiked] = useState(false);

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2200);
  };

  const handleCopy = async () => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    try {
      await navigator.clipboard.writeText(url);
      showToast("链接已复制（演示效果）");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  return (
    <div className={`relative flex flex-wrap items-center gap-2 ${className}`}>
      <button
        type="button"
        onClick={() => {
          setLiked((v) => !v);
          showToast(liked ? "已取消点赞（演示效果）" : "感谢点赞（演示效果）");
        }}
        className={`flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-sm transition-colors whitespace-nowrap ${
          liked
            ? "border-accent-300 bg-accent-50 text-accent-700"
            : "border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-accent-700"
        }`}
      >
        <i className={liked ? "ri-thumb-up-fill" : "ri-thumb-up-line"} aria-hidden="true"></i>
        点赞
      </button>

      <button
        type="button"
        onClick={handleCopy}
        className="flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
      >
        <i className="ri-link" aria-hidden="true"></i>
        复制链接
      </button>

      <button
        type="button"
        onClick={() => showToast(`已唤起分享面板：${title}（演示效果）`)}
        className="flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
      >
        <i className="ri-wechat-line" aria-hidden="true"></i>
        微信分享
      </button>

      {toast ? (
        <span className="pointer-events-none absolute -top-9 left-0 rounded-md bg-primary-900 px-3 py-1.5 text-xs text-background-50 animate-fade-in">
          {toast}
        </span>
      ) : null}
    </div>
  );
}